export var platforms = [
    {
        name: 'iOS',
        test: /iphone|ipad/gi
    },
    {
        name: 'android',
        test: /android/gi
    },
    {
        name: 'UNKNOWN',
        test: function () { return true; }
    }
];
export var devices = [
    {
        name: 'iphone',
        test: /iphone/gi
    },
    {
        name: 'ipad',
        test: /ipad/gi
    },
    {
        name: 'android',
        test: /android/gi
    },
    {
        name: 'pc',
        test: function () { return true; }
    }
];
export var apps = [
    // lite的ua也符合头条的ua，所以需要在前面
    {
        name: 'toutiaolite',
        bType: 7,
        aid: 35,
        test: /NewsLite(?:|InHouse)\s([\d.]+)/i
    },
    {
        name: 'toutiao',
        bType: 3,
        aid: 13,
        test: /NewsArticle\/([\d.]+)/i
    },
    {
        name: 'xigua',
        bType: 4,
        aid: 32,
        test: /VideoArticle\/([\d.]+)/i
    },
    {
        name: 'huoshan',
        bType: 1,
        aid: 1112,
        test: /live_stream_([\d.]+)/i
    },
    {
        name: 'douyin',
        bType: 2,
        aid: 1128,
        test: /aweme_([\d.]+)/i
    },
    {
        name: 'flash',
        bType: 6,
        aid: 0,
        test: /ecom_huimai\/([\d.]+)/i
    },
    {
        name: 'wechat',
        bType: 5,
        aid: 0,
        test: /MicroMessenger\/([\d.]+)/i
    },
    {
        name: 'automobile',
        bType: 8,
        aid: 36,
        test: /(AutoMobile|AutoMobileInHouse|AutoMobileInHouseTest)[/ ]([\d.]+)/i
    },
    {
        name: 'super',
        bType: 9,
        aid: 1319,
        test: /Super\s?([\d.]+)/i
    },
    // 抖店
    {
        name: 'merchant',
        bType: 0,
        aid: 3102,
        test: /merchant(?:|.inhouse)\/([\d.]+)/i
    },
    {
        name: 'aweme_lite',
        bType: 11,
        aid: 2329,
        test: /aweme_lite_([\d.]+)/i
    },
    {
        name: 'huoshan_lite',
        bType: 0,
        aid: 1350,
        test: /live_stream_lite_([\d.]+)/i
    },
    {
        name: 'UNKNOWN',
        bType: 0,
        aid: 0,
        test: function () { return true; }
    }
];
